<template>
  <div class="p2a-copyright">
    <p>
      <span>{{ footerSettings.content }}</span>
      <span v-if="footerSettings.hidePrivacyPolicy === 0 || hasCustomPrivacyText === true">{{ footerSettings.subjectTo }} </span>
      <a
        v-if="footerSettings.hidePrivacyPolicy === 0"
        href="https://phone2action.com/privacy-policy/"
        target="_blank"
        aria-label="Privacy Policy">{{ footerSettings.privacyPolicyLabel }}</a><span v-if="footerSettings.hidePrivacyPolicy === 0 && hasCustomPrivacyText === false">.</span>
      <span v-if="footerSettings.hidePrivacyPolicy === 0 && hasCustomPrivacyText">{{ footerSettings.andLabel }} </span>
      <a
        v-if="hasCustomPrivacyText"
        :href="footerSettings.privacyPolicyUrl"
        target="_blank">{{ footerSettings.privacyPolicyUrlLabel }}.</a>
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FooterSection",
  computed: {
    ...mapState("wdyk", {
      footerSettings: state => state.footerSettings
    }),
    hasCustomPrivacyText() {
      return !!(
        this.footerSettings.privacyPolicyUrl &&
        this.footerSettings.privacyPolicyUrlLabel
      );
    }
  }
};
</script>
